export default "__VITE_ASSET__fbd9ec24__"